import { ReactNode, TextareaHTMLAttributes, forwardRef } from 'react';
import { Label } from 'src/shared/components/typography/Label';
import { useOrg } from 'src/shared/contexts/OrgContext';
import { cn } from 'src/shared/lib/utils';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string | ReactNode;
  allowReadOnly?: boolean;
  disableGrammarly?: boolean;
}

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, label, allowReadOnly, disableGrammarly = true, ...props }, ref) => {
    const { role } = useOrg();
    // Generate ID only for string labels
    const id = typeof label === 'string' ? label?.replace(' ', '') : undefined;

    return (
      <div className="w-full group px-0.5">
        {label && <Label htmlFor={id}>{label}</Label>}

        <textarea
          id={id}
          readOnly={role === 'READER' && !allowReadOnly}
          className={cn(
            'flex h-16 input-focus placeholder:text-typography-grey focus-within:border-black w-full rounded-sm border bg-background px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:cursor-not-allowed',
            className
          )}
          ref={ref}
          data-gramm="false"
          data-gramm_editor="false"
          data-enable-grammarly="false"
          spellCheck={disableGrammarly ? 'false' : undefined}
          {...props}
        />
      </div>
    );
  }
);
TextArea.displayName = 'TextArea';

export { TextArea };
